import type { PieChartLegendConfig } from '../types/pie-chart.config.js';

/**
 * Legend slot component.
 */
export const Legend = (props: PieChartLegendConfig) => null;

Legend['displayName'] = 'PieChart.Legend';
